import { render, staticRenderFns } from "./UContents.vue?vue&type=template&id=f533a38e&scoped=true&"
import script from "./UContents.vue?vue&type=script&lang=ts&"
export * from "./UContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f533a38e",
  null
  
)

export default component.exports